import { render } from "./Box_m.vue?vue&type=template&id=712301ad&scoped=true"
import script from "./Box_m.vue?vue&type=script&lang=js"
export * from "./Box_m.vue?vue&type=script&lang=js"

import "./Box_m.vue?vue&type=style&index=0&id=712301ad&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-712301ad"

export default script